import React from 'react'

export default () => (
  <div>
    <h1>Account</h1>
  </div>
)
